import React from 'react';
import { ListItemButton, styled, Tooltip, tooltipClasses, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

function SDListItem({ i }) {
    return <NrmlItem i={i} key={i.title} />
}

function NrmlItem({ i }) {
    const navigate = useNavigate();
    const location = useLocation();
    const selsStyle = i.selsStyle ?? {
        height: '1.45rem',
        marginLeft: '0.1rem',
        marginRight: '0.1rem',
    }
    const deSelStyle = i.deSelStyle ?? {
        height: '1.45rem',
        marginLeft: '0.1rem',
        marginRight: '0.1rem',
    }

    return (
        <HtmlTooltip title={
            <React.Fragment>
                <Typography component={'h3'}>{i.title}</Typography>
            </React.Fragment>} placement="right">

            <ListItemButton key={i.title}
                sx={{
                    alignItems: "center", py: 2
                }}
                onClick={() => { navigate(i.path) }}>
                <img src={location.pathname !== i.path ? i.deSelImgPath : i.selImgPath} alt="side drawer img"
                    style={location.pathname !== i.path ? deSelStyle : selsStyle} />
            </ListItemButton>

        </HtmlTooltip>
    )
}


export default SDListItem